<!--<c-footer>-->
  <div>
    <!-- <a href="https://coreui.io/" target="_blank">CoreUI</a>
    <span> &copy; 2024 creativeLabs</span>
  </div>
  <div class="ms-auto">
    Powered by
    <a href="https://coreui.io/angular" target="_blank">
      <span> CoreUI for Angular</span>
    </a> -->
  </div>
<!--</c-footer>-->
